import axios from "axios";
import { endpoints } from "../config";
import { getData, postData } from "./api-utils";

const getAllBilet = async () => {
  return await getData(endpoints.bilet);
};

const initBiletTest = async (biletId, type, session) => {
  return await getData(
    endpoints.biletQuestions +
      "/" +
      biletId +
      "?" +
      new URLSearchParams({ type, session })
  );
};

const submiAnswer = async (testId, answerId, questionId) => {
  return await postData(endpoints.bilet + "/question/" + testId, {
    answerId,
    questionId,
  });
};

const getThemeList = async () => {
  return await getData(endpoints.theme);
};

const finishTest = async (biletId, type, session) => {
  return postData(
    endpoints.biletFinish +
      "/" +
      biletId +
      "?" +
      new URLSearchParams({ type, session })
  );
};

const canceleTest = (biletId, type, session) => {
  return postData(
    endpoints.biletCancele +
      "/" +
      biletId +
      "?" +
      new URLSearchParams({ type, session })
  );
};

export {
  getAllBilet,
  initBiletTest,
  submiAnswer,
  getThemeList,
  finishTest,
  canceleTest,
};
